export const GET_MESSAGES_PATH = 'api/landlord/messages/from-lead';